import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useEvalStewardEnabled } from "./useEvalStewardEnabled";

export interface FeedbackThreadParams {
  workspaceId: string;
  threadId: string;
}

export function useFeedbackThread({
  workspaceId,
  threadId,
}: FeedbackThreadParams) {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  return useQuery({
    queryKey: ["evalSteward", "feedbackThread", workspaceId, threadId],
    queryFn: () => api.getThread(workspaceId, threadId),
    enabled:
      isEvalStewardEnabled && Boolean(workspaceId && threadId),
  });
}
